import http from "../http-common";

const login = (data: { username: string; password: string }) => {
  return http.post("/auth/login", data);
};

const refresh = (data: { refreshToken: string }) => {
  return http.post("/auth/refresh", data);
};

const changePassword = (data: { oldPassword: string; newPassword: string }) => {
  return http.put("/auth/change-password", data);
};

const googleLogin = (data: { idToken: string }) => {
  return http.post("/auth/google", data);
};

const AuthService = {
  login,
  googleLogin,
  refresh,
  changePassword,
};

export default AuthService;
